import apiClient from './client';

/**
 * JUB-157: a plan purchase belongs to one event. `unassigned` purchases are
 * legacy ones paid before that rule; each can be applied once, explicitly.
 */
export type PurchaseStatus = 'active' | 'unassigned' | 'consumed' | 'refunded' | 'transferred';

export interface Purchase {
  id: number;
  plan: 'standard' | 'premium';
  status: PurchaseStatus;
  eventUuid: string | null;
  eventName: string | null;
  amount: number | null;
  currency: string | null;
  boundAt: string | null;
  createdAt: string | null;
}

export interface PurchasesResponse {
  items: Purchase[];
  unassignedCount: number;
}

type Envelope<T> = { message_key?: string; data?: T } | T;

function unwrap<T>(payload: Envelope<T>): T {
  if (payload && typeof payload === 'object' && 'data' in payload && payload.data !== undefined) {
    return payload.data as T;
  }
  return payload as T;
}

export async function getPurchases(): Promise<PurchasesResponse> {
  const response = await apiClient.get<Envelope<PurchasesResponse>>('/purchases');
  const data = unwrap(response.data);
  return { items: data?.items ?? [], unassignedCount: data?.unassignedCount ?? 0 };
}

/**
 * Apply an unassigned purchase to one of the owner's events. Irreversible.
 */
export async function bindPurchase(purchaseId: number, eventUuid: string): Promise<Purchase> {
  const response = await apiClient.post<Envelope<Purchase>>(`/purchases/${purchaseId}/bind`, {
    eventUuid,
    confirmIrreversible: true,
  });
  return unwrap(response.data);
}
